<fuse-progress-bar></fuse-progress-bar>

<div id="main">


    <div id="container-1" class="container">

        <!-- NAVBAR: Left -->
        <ng-container >
            <ng-container *ngTemplateOutlet="leftNavbar" ></ng-container>
        </ng-container>
        <!-- / NAVBAR: Left -->

        <div id="container-2" class="container">


<!--[fusePerfectScrollbarOptions]="{suppressScrollX: true, updateOnRouteChange : true}-->
            <div id="container-3" class="container" fusePerfectScrollbar>

                <!-- TOOLBAR: Below static -->
                <ng-container>
                    <ng-container *ngTemplateOutlet="toolbar"></ng-container>
                </ng-container>
                <!-- / TOOLBAR: Below static -->

                <!-- CONTENT -->
                <content></content>
                <!-- / CONTENT -->



            </div>



        </div>

    </div>



</div>






<!-- TOOLBAR -->
<ng-template #toolbar>
    <toolbar [ngClass]="below-static">
    </toolbar>
</ng-template>
<!-- / TOOLBAR -->



<!-- LEFT NAVBAR -->
<ng-template #leftNavbar>
    <fuse-sidebar name="navbar" style="background:#1e2129;" class="navbar-fuse-sidebar" [folded]="false"
        lockedOpen="gt-md">
        <navbar class="left-navbar"></navbar>
    </fuse-sidebar>
</ng-template>
<!-- / LEFT NAVBAR -->

<!-- THEME OPTIONS PANEL -->
<!--
<button mat-icon-button class="warn mat-elevation-z2 theme-options-button"
    (click)="toggleSidebarOpen('themeOptionsPanel')">
    <mat-icon>settings</mat-icon>
</button>

<fuse-sidebar name="themeOptionsPanel" class="theme-options-sidebar" position="right">
    <fuse-theme-options></fuse-theme-options>
</fuse-sidebar>
-->
<!-- / THEME OPTIONS PANEL -->